import {
  LEGAL_DOCUMENT_BODY_LENGTH,
  LEGAL_DOCUMENT_LENGTH,
  normalizeLegalDocument,
} from './document';

const getLegalDocumentCharacterValue = (character: string): number =>
  character.charCodeAt(0) - 48;

const calculateLegalDocumentVerifier = (document: string): string => {
  let sum = 0;
  let weight = 2;

  for (let index = document.length - 1; index >= 0; index--) {
    sum += getLegalDocumentCharacterValue(document[index]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const rest = sum % 11;

  return rest < 2 ? '0' : String(11 - rest);
};

export function validateLegalDocument(document: string): boolean {
  if (document === undefined || typeof document !== 'string') {
    return false;
  }

  const normalizedDocument = normalizeLegalDocument(document);

  if (
    !/^[A-Z0-9]{12}\d{2}$/.test(normalizedDocument) ||
    (/\d{14}/.test(normalizedDocument) && /^(\d)\1+$/.test(normalizedDocument))
  ) {
    return false;
  }

  const baseDocument = normalizedDocument.substring(
    0,
    LEGAL_DOCUMENT_BODY_LENGTH
  );
  const verifiers = normalizedDocument.substring(
    LEGAL_DOCUMENT_BODY_LENGTH,
    LEGAL_DOCUMENT_LENGTH
  );

  const firstVerifier = calculateLegalDocumentVerifier(baseDocument);
  const secondVerifier = calculateLegalDocumentVerifier(
    `${baseDocument}${firstVerifier}`
  );

  return verifiers === `${firstVerifier}${secondVerifier}`;
}
